<template>
  <div class="row filter-row">
    <div
      v-for="filter of filters"
      :key="filter.name"
      :class="['col', filter.isText ? 'col-4' : 'col-auto', 'col-filter']"
    >
      <grid-filter-text
        v-if="filter.isText"
        :filter="filter"
        :model-value="filter.selectedValueString"
        @update:model-value="value => onFilterSelected(filter, value)"
      />

      <grid-filter-daterange
        v-if="filter.isDateRange"
        :filter="filter"
        :model-value="filter.selectedValueArray"
        @update:model-value="value => onFilterSelected(filter, value)"
      />

      <grid-filter-list
        v-if="filter.isList"
        :filter="filter"
        :model-value="filter.selectedValueArray"
        @update:model-value="value => onFilterSelected(filter, value)"
      />

      <grid-filter-autocomplete
        v-if="filter.isAutocomplete"
        :filter="filter"
        :model-value="filter.selectedValueArray"
        @update:model-value="value => onFilterSelected(filter, value)"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import GridFilterAutocomplete from './grid-filter-autocomplete.vue'
import GridFilterDaterange from './grid-filter-daterange.vue'
import GridFilterList from './grid-filter-list.vue'
import GridFilterText from './grid-filter-text.vue'
import type {GridFilter} from './types'

defineProps({
  filters: {type: Array as () => GridFilter[], default: (): GridFilter[] => []}
})

const emit = defineEmits<{
  (e: 'selected', filter: GridFilter, filterValue: string | string[]): void
}>()

const onFilterSelected = (filter: GridFilter, filterValue: string | string[]): void => {
  emit('selected', filter, filterValue)
}

</script>
